/**
 * Extracts the recognition ID from a recognition row object
 * Checks multiple possible field names in order of preference
 */
export const getRecognitionId = (row: any): any => {
  return row?.recognition_id || row?.id || row?.recognition_event_id
}

/**
 * Checks if a recognition row has an associated reward
 */
export const hasReward = (row: any): boolean => {
  return !!row.reward_amount && parseFloat(row.reward_amount) > 0
}
